// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {NavLink, Route, Switch} from 'react-router-dom'
import history from '../../history'

import Title from '../Title/'

import './index.css'

import Products from './Products'
import ProfilesTable from './ProfilesTable'

import config, {FETAURE_USER_MANAGEMENT_PRODUCTS, FEATURE_USER_MANAGEMENT_PROFILES} from '../../config'

// Icons
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined'

const profiles_flag = config[FEATURE_USER_MANAGEMENT_PROFILES]
const products_flag = config[FETAURE_USER_MANAGEMENT_PRODUCTS]

export default class UserManagement extends Component {
  menuItems () {
    return [
      profiles_flag && (<li className='nav-item' key='profiles'>
        <NavLink className='nav-link' to={`/user-management/profiles/`} key='profiles'> Profiles </NavLink>
      </li>),
      products_flag && (<li className='nav-item' key='products'>
        <NavLink className='nav-link' to={`/user-management/products/`} key='products'> Products </NavLink>
      </li>),
    ]
  }

  render () {
    return (
      <div className='user-management'>
        <div className='container-fluid page-content'>
          <Title>
            <SupervisorAccountOutlinedIcon/>&nbsp; User Management
          </Title>
          <div className='col-12'>
            <div>
              <ul className='nav nav-tabs'>
                {this.menuItems()}
              </ul>
            </div>
            <div className='inner-div'>
              <Switch>
                {profiles_flag && <Route path='/user-management/profiles/' component={ProfilesTable}/>}
                {products_flag && <Route path='/user-management/products/' component={Products}/>}
                {(profiles_flag) && <Route path='/user-management/' render={() => <>{history.replace('/user-management/profiles/')}</>} />}
                {(products_flag) && <Route path='/user-management/' render={() => <>{history.replace('/user-management/products/')}</>} />}
              </Switch>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
